/**
 *
 * @license Royal Canin
 * @contributors :
 *  - Amar YASSA
 */

import { createReducer, Action, on } from '@ngrx/store';
import { resetShareRecommendation, setShareRecommendation } from './share-recommendation.actions';
import { initialShareRecommendationState, ShareRecommendationState } from './share-recommendation.state';

const _shareRecommendationReducer = createReducer(
  initialShareRecommendationState,
  on(
    setShareRecommendation,
    (state, { data }): ShareRecommendationState => ({
      ...state,
      data,
    })
  ),
  on(resetShareRecommendation, () => initialShareRecommendationState)
);

export function shareRecommendationReducer(state: ShareRecommendationState | undefined, action: Action) {
  return _shareRecommendationReducer(state, action);
}
